export class InvCoutingAssistantEntity{
    id:number;
    coutingId:number;
    personId:number;
    person:string;
    active:boolean;

    constructor(){}
}